import { CCardFooter } from "@coreui/react";
import { Box, Button, Card, CardContent, CardHeader, Divider, MenuItem, Select,  Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography,SelectChangeEvent, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import NeonModal from "../../component/neon/NeonModal";
import { T_user } from "../../common/model/user";
import apis from "../../common/apis";
import { useLocation, useNavigate } from "react-router-dom";
import { initialAlert, useAlert } from "../../provider/AlertContextProvider";


export default function UserEdit(){

     const { state } = useLocation();
    // state.inqueryData 에서 넘어온 item 객체를 꺼낼 수 있습니다.
    const paramData = state?.item;
    
    const nav = useNavigate();
    
    const [role,setRole] = useState("");
    const [isPassModal,setIsPassModal] = useState(false);

    const [data,setData] = useState<T_user>({role:"ADMIN"})
    const [sendData,setSendData] = useState<T_user>({userId:paramData.userId})

     const [isMatch, setIsMatch] = useState(true);

    const {alert,setAlert} = useAlert();

    const handlePassClose = ()=>{
        setIsPassModal(false);
    }

     const handlePassOpen = ()=>{
        setIsPassModal(true);
    }

    const getData = async()=>{

        const result = await apis.user.userInfo({userId:paramData.userId})
        console.log("userInfo:",result.data)
        if(result.code=="1"){
            setData(result.data)
        }
    }

      const updatePass = async()=>{

       if(!isMatch){
            setAlert({...alert,visible:true,msg:"비밀번호를 확인 해주세요"})
            return;
        } 


        setAlert({...alert,title:"확인",msg:"정말로 변경 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.user.userUpdate(sendData)   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        nav("/user")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }

     const updateData = async()=>{

       if(!isMatch){
            setAlert({...alert,visible:true,msg:"비밀번호를 확인 해주세요"})
            return;
        } 


        setAlert({...alert,title:"확인",msg:"정말로 변경 하시겠습니가?",visible:true,buttonList:[
            {
                text:"예"
                ,variant:"contained"
                ,onPress:async()=>{
                    const result = await apis.user.userUpdate(sendData)   
                    console.log("result:",result);
                    if(result.code=="1"){
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정이 완료되었습니다."})
                        nav("/user")
                    }else{
                        setAlert(initialAlert);
                        setAlert({...alert,visible:true,title:"확인",msg:"수정정중 오류가 발생했습니다.."})
                    }
           
                }
            },{
                text:"아니요"
                ,variant:"outlined"
                ,onPress:()=>{
                    setAlert(initialAlert);
                }
            }
        ]})


      }      
    useEffect(()=>{
        getData();
    },[])

    useEffect(() => {
        if (sendData.userPw === '' && sendData.userPw1 === '') {
            setIsMatch(true);
        } else {
            setIsMatch(sendData.userPw === sendData.userPw1);
        }
    }, [sendData.userPw, sendData.userPw1]);


        return(
            <>
             <Card >
        <CardHeader title="관리자 수정" sx={{pb:0,mb:0}}/>
        <CardContent>
            <Divider />
        <Table  stickyHeader aria-label="sticky table"  sx={{borderTopWidth:2
          }} > 
            <TableHead />
            <TableBody>
            <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          아이디
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}}>
                             <Typography
                                  sx={{
                                    ml: 1,
                                    color: 'error.main',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                 {data.userId}
                                </Typography>
                        </TableCell>      
                        <TableCell component="th" scope="row" sx={{width:150}}>
                          패스워드
                        </TableCell>      
                         <TableCell sx={{textAlign:'left'}}>
                          <Button onClick={()=>{
                            setIsPassModal(true);
                          }

                          }>비밀번호 변경</Button>
                        </TableCell>                         
          </TableRow>        
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          사용자명
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                         <TextField   size="small" fullWidth value={data.userNm || ''} onChange={(event)=>{setData({...data,userNm:event.target.value})}} 
                           inputProps={{ maxLength: 20 }} // 여기에 최대 길이 지정
                            sx={{ width: '40ch' }}
                          />
                        </TableCell>      

        </TableRow>          
        <TableRow>
                    <TableCell component="th" scope="row" sx={{width:150}}>
                          권한
                        </TableCell>      
                        <TableCell sx={{textAlign:'left'}} colSpan={3}>
                            <Select
                                value={data.role}
                                readOnly={data.role=="ADMIN"?true:false}
                                size="small"
                                onChange={(event:SelectChangeEvent)=>{
                                setData({...data,role:event.target.value})
                                }}
                            >
                                <MenuItem value="ADMIN">관리자</MenuItem>
                                <MenuItem value="MANAGER">담당자</MenuItem>
                                <MenuItem value="USER">사용자</MenuItem>
                                <MenuItem value="GUEST">미승인</MenuItem>
                            </Select>
                        </TableCell>      
        </TableRow>          
        </TableBody>

        </Table>

        </CardContent>
        <CCardFooter style={{   display: 'flex',justifyContent:'center',textAlign:'center',paddingBottom:10, gap: '1rem'}}  >
        <Button variant="contained"  onClick={()=>{
          updateData();
          }}>저장</Button>
        <Button variant="outlined" onClick={()=>{
          nav(-1);
         }}>취소</Button>

        </CCardFooter>
    </Card>
     <NeonModal
             open={isPassModal}
             onClose={handlePassClose}
             title="비밀번호변경"
             btnList={[
                   {
                     text:"예"
                     ,variant:'contained'
                     ,onPress:()=>{
                       updatePass();
                     }
                   },
                   {
                     text:"아니오"
                     ,onPress:()=>{
                       handlePassClose();
                     }
                   }
   
             ]}
             content={  <Table>
               <TableBody>
                 <TableRow>
                 <TableCell>새비밀번호</TableCell>
                 <TableCell>
                          <Box sx={{display:'flex',flexDirection:'row',mb:2}}><TextField type="password"   size="small" fullWidth value={sendData.userPw || ''} onChange={(event)=>{setSendData({...sendData,userPw:event.target.value})}} 

                            />
                          </Box>
                        <Box sx={{display:'flex',flexDirection:'row'}}><TextField size="small" type="password" fullWidth value={sendData.userPw1 || ''} onChange={(event)=>{setSendData({...sendData,userPw1:event.target.value});}} />
                          </Box>
                    <Typography
                                  sx={{
                                    ml: 1,
                                    color: 'error.main',
                                    whiteSpace: 'nowrap',
                                    // 에러 없을 때는 숨기고, 있을 때만 보이기
                                    // 메시지가 길어도 줄바꿈 안 되도록
                                    visibility: isMatch ? 'hidden' : 'visible',
                                  }}
                                  
                                >
                                  패스워드가 일치하지 않습니다
                                </Typography>
                 </TableCell>
                 </TableRow>
               </TableBody>
             </Table>}
           />
            </>
        )
}